import { DepartmentDto, OperationAvailabilityDto } from "../../autogen/bff-api";
import { showsProjectDepartment } from "./departmentVisibility";

const CREATE_SOURCING_EVENT = "CreateSourcingEvent";
const CREATE_PROJECT = "CreateProject";

const allows = (operations: OperationAvailabilityDto[] | undefined, operation: string): boolean =>
  operations?.some((o) => o.operation === operation && o.allowed) ?? false;

export const departmentsForNewEvent = (org: { departments?: DepartmentDto[] }): DepartmentDto[] =>
  (org.departments ?? []).filter((d) => allows(d.operations, CREATE_SOURCING_EVENT));

export const departmentsForNewProject = (org: { departments?: DepartmentDto[] }): DepartmentDto[] =>
  (org.departments ?? []).filter((d) => allows(d.operations, CREATE_PROJECT));

export const projectDepartmentOptions = (org: { departments?: DepartmentDto[] }): DepartmentDto[] =>
  creatableDepartments(org);

export const departmentName = (org: { departments?: DepartmentDto[] }, departmentId: string | null | undefined) =>
  departmentId ? (org.departments ?? []).find((d) => d.id === departmentId)?.name : undefined;

// Only listOrganizationsForMe populates DepartmentDto.operations; empty means "not evaluated" there.
const creatableDepartments = (org: { departments?: DepartmentDto[] }): DepartmentDto[] => {
  const evaluated = departmentsForNewProject(org);
  return evaluated.length > 0 ? evaluated : (org.departments ?? []);
};

// A hidden picker still has to supply a department: the BFF requires one on every project.
export const initialProjectDepartmentId = (org: { departments?: DepartmentDto[] }): string | undefined => {
  const creatable = creatableDepartments(org);
  if (!showsProjectDepartment(org)) return (creatable.find((d) => d.isDefault) ?? creatable[0])?.id;
  return creatable.length === 1 ? creatable[0].id : undefined;
};
